import phone from "./images/img_0.png";
import icon from "./images/img_1.png";

export default {
  v: "5.5.9",
  fr: 24,
  ip: 0,
  op: 106,
  w: 1000,
  h: 1000,
  nm: "15M_WhatsApp",
  ddd: 0,
  assets: [
    { id: "image_0", w: 435, h: 488, u: "", p: phone, e: 0 },
    { id: "image_1", w: 603, h: 1074, u: "", p: icon, e: 0 },
    {
      id: "comp_0",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 2,
          nm: "SP2_03.png",
          cl: "png",
          refId: "image_0",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 8,
                  s: [100],
                },
                { t: 13, s: [100] },
              ],
              ix: 11,
            },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 8,
                  s: [0],
                },
                { t: 13, s: [0] },
              ],
              ix: 10,
            },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 8,
                  s: [323.5, 503, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                { t: 13, s: [323.5, 503, 0] },
              ],
              ix: 2,
            },
            a: { a: 0, k: [217.5, 244, 0], ix: 1 },
            s: {
              a: 1,
              k: [
                {
                  i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                  o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                  t: 8,
                  s: [0, 0, 100],
                },
                {
                  i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                  o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                  t: 13,
                  s: [80, 80, 100],
                },
                {
                  i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                  o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                  t: 84,
                  s: [80, 80, 100],
                },
                { t: 89, s: [0, 0, 100] },
              ],
              ix: 6,
            },
          },
          ao: 0,
          ip: 0,
          op: 360,
          st: 0,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 2,
          nm: "SP2_01.png",
          cl: "png",
          refId: "image_1",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [301.5, 537, 0], ix: 2 },
            a: { a: 0, k: [301.5, 537, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 },
          },
          ao: 0,
          ip: 0,
          op: 360,
          st: 0,
          bm: 0,
        },
      ],
    },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 0,
      nm: "Phone Comp 1",
      refId: "comp_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [550, 466, 0], ix: 2 },
        a: { a: 0, k: [301.5, 537, 0], ix: 1 },
        s: { a: 0, k: [66.169, 66.169, 100], ix: 6 },
      },
      ao: 0,
      w: 603,
      h: 1074,
      ip: 0,
      op: 106,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: "Shape Layer 1",
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [540, 120.5, 0], ix: 2 },
        a: { a: 0, k: [27.059, -414, 0], ix: 1 },
        s: { a: 0, k: [100, 82.171, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [842.117, 830.102], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [0, 0.333333333333, 0.588235294118, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 1, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0.333333333333, 0.588235294118, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [27.059, 1.051], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Rectangle 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 106,
      st: -7,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: "PCC chat-23 Outlines",
      tt: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 0.667 },
              o: { x: 0.333, y: 0.333 },
              t: -7,
              s: [919.399, 2143.29, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 3,
              s: [919.399, 2143.29, 0],
              to: [0, -13.5, 0],
              ti: [0, 13.5, 0],
            },
            {
              i: { x: 0.667, y: 0.667 },
              o: { x: 0.333, y: 0.333 },
              t: 8,
              s: [919.399, 2062.29, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 18,
              s: [919.399, 2062.29, 0],
              to: [0, -13.542, 0],
              ti: [0, 13.542, 0],
            },
            {
              i: { x: 0.667, y: 0.667 },
              o: { x: 0.333, y: 0.333 },
              t: 23,
              s: [919.399, 1981.04, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 33,
              s: [919.399, 1981.04, 0],
              to: [0, -21.021, 0],
              ti: [0, 21.021, 0],
            },
            {
              i: { x: 0.667, y: 0.667 },
              o: { x: 0.333, y: 0.333 },
              t: 38,
              s: [919.399, 1854.915, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 48,
              s: [919.399, 1854.915, 0],
              to: [0, -13.417, 0],
              ti: [0, 13.417, 0],
            },
            {
              i: { x: 0.667, y: 0.667 },
              o: { x: 0.333, y: 0.333 },
              t: 53,
              s: [919.399, 1774.415, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 63,
              s: [919.399, 1774.415, 0],
              to: [0, -13.573, 0],
              ti: [0, 13.573, 0],
            },
            {
              i: { x: 0.667, y: 0.667 },
              o: { x: 0.333, y: 0.333 },
              t: 68,
              s: [919.399, 1692.977, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 78,
              s: [919.399, 1692.977, 0],
              to: [0, -24.625, 0],
              ti: [0, 24.625, 0],
            },
            {
              i: { x: 0.667, y: 0.667 },
              o: { x: 0.333, y: 0.333 },
              t: 83,
              s: [919.399, 1545.227, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 93,
              s: [919.399, 1545.227, 0],
              to: [0, -13.5, 0],
              ti: [0, 13.5, 0],
            },
            {
              i: { x: 0.667, y: 0.667 },
              o: { x: 0.333, y: 0.333 },
              t: 98,
              s: [919.399, 1464.227, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 109,
              s: [919.399, 1464.227, 0],
              to: [0, -14.385, 0],
              ti: [0, 14.385, 0],
            },
            { t: 114, s: [919.399, 1377.915, 0] },
          ],
          ix: 2,
        },
        a: { a: 0, k: [758.798, 2018, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.149, 0],
                    [0, 0],
                    [0, 7.148],
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.148],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.148],
                    [0, 0],
                    [7.149, 0],
                    [0, 0],
                    [0, 7.148],
                  ],
                  v: [
                    [132.659, 30.538],
                    [-132.66, 30.538],
                    [-145.603, 17.594],
                    [-145.603, -17.594],
                    [-132.66, -30.538],
                    [132.659, -30.538],
                    [145.603, -17.594],
                    [145.603, 17.594],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.998915848078, 0.694012989717, 0.016330733954, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [758.125, 62.296], ix: 2 },
              a: { a: 0, k: [144.93, 31.049], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667, 0.667], y: [1, 1] },
                    o: { x: [0.333, 0.333], y: [0, 0] },
                    t: 2,
                    s: [100, 100],
                  },
                  { t: 7, s: [0, 0] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 3",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.149, 0],
                    [0, 0],
                    [0, 7.148],
                    [0, 0],
                    [-7.149, 0],
                    [0, 0],
                    [0, -7.148],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.149, 0],
                    [0, 0],
                    [0, -7.148],
                    [0, 0],
                    [7.149, 0],
                    [0, 0],
                    [0, 7.148],
                  ],
                  v: [
                    [30.753, 30.537],
                    [-30.753, 30.537],
                    [-43.696, 17.594],
                    [-43.696, -17.594],
                    [-30.753, -30.537],
                    [30.753, -30.537],
                    [43.696, -17.594],
                    [43.696, 17.594],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.998915848078, 0.694012989717, 0.016330733954, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [758.441, 143.406], ix: 2 },
              a: { a: 0, k: [43.34, 31.084], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667, 0.667], y: [1, 1] },
                    o: { x: [0.333, 0.333], y: [0, 0] },
                    t: 17,
                    s: [100, 100],
                  },
                  { t: 22, s: [0, 0] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 4",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.148, 0],
                    [0, 0],
                    [0, 7.149],
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.149],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.149],
                    [0, 0],
                    [7.148, 0],
                    [0, 0],
                    [0, 7.149],
                  ],
                  v: [
                    [132.6, 53.085],
                    [-132.72, 53.085],
                    [-145.663, 40.141],
                    [-145.663, -40.14],
                    [-132.72, -53.085],
                    [132.6, -53.085],
                    [145.543, -40.14],
                    [145.543, 40.141],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0.333333333333, 0.588235294118, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [-0.302, 268.171], ix: 2 },
              a: { a: 0, k: [-146.482, 51.455], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667, 0.667], y: [1, 1] },
                    o: { x: [0.333, 0.333], y: [0, 0] },
                    t: 32,
                    s: [100, 100],
                  },
                  { t: 37, s: [0, 0] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 2",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.148, 0],
                    [0, 0],
                    [0, 7.148],
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.149],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.149],
                    [0, 0],
                    [7.148, 0],
                    [0, 0],
                    [0, 7.148],
                  ],
                  v: [
                    [94.974, 30.538],
                    [-95.094, 30.538],
                    [-108.038, 17.594],
                    [-108.038, -17.594],
                    [-95.094, -30.538],
                    [94.974, -30.538],
                    [107.917, -17.594],
                    [107.917, 17.594],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0.333333333333, 0.588235294118, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [-0.058, 349.283], ix: 2 },
              a: { a: 0, k: [-108.096, 29.717], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667, 0.667], y: [1, 1] },
                    o: { x: [0.333, 0.333], y: [0, 0] },
                    t: 47,
                    s: [100, 100],
                  },
                  { t: 52, s: [0, 0] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 5",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.149, 0],
                    [0, 0],
                    [0, 7.148],
                    [0, 0],
                    [-7.149, 0],
                    [0, 0],
                    [0, -7.149],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.149, 0],
                    [0, 0],
                    [0, -7.149],
                    [0, 0],
                    [7.149, 0],
                    [0, 0],
                    [0, 7.148],
                  ],
                  v: [
                    [62.307, 30.537],
                    [-62.307, 30.537],
                    [-75.252, 17.594],
                    [-75.252, -17.594],
                    [-62.307, -30.537],
                    [62.307, -30.537],
                    [75.251, -17.594],
                    [75.251, 17.594],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.998915848078, 0.694012989717, 0.016330733954, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [758.511, 431.066], ix: 2 },
              a: { a: 0, k: [74.964, 30.425], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667, 0.667], y: [1, 1] },
                    o: { x: [0.333, 0.333], y: [0, 0] },
                    t: 62,
                    s: [100, 100],
                  },
                  { t: 67, s: [0, 0] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 6",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.149, 0],
                    [0, 0],
                    [0, 7.149],
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.149],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.149],
                    [0, 0],
                    [7.149, 0],
                    [0, 0],
                    [0, 7.149],
                  ],
                  v: [
                    [132.659, 63.776],
                    [-132.66, 63.776],
                    [-145.603, 50.832],
                    [-145.603, -50.832],
                    [-132.66, -63.776],
                    [132.659, -63.776],
                    [145.603, -50.832],
                    [145.603, 50.832],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.998915848078, 0.694012989717, 0.016330733954, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [758.951, 578.942], ix: 2 },
              a: { a: 0, k: [145.756, 63.987], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667, 0.667], y: [1, 1] },
                    o: { x: [0.333, 0.333], y: [0, 0] },
                    t: 77,
                    s: [100, 100],
                  },
                  { t: 82, s: [0, 0] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 6,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.148, 0],
                    [0, 0],
                    [0, 7.149],
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.148],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.148],
                    [0, 0],
                    [7.148, 0],
                    [0, 0],
                    [0, 7.149],
                  ],
                  v: [
                    [132.6, 30.537],
                    [-132.72, 30.537],
                    [-145.663, 17.594],
                    [-145.663, -17.594],
                    [-132.72, -30.537],
                    [132.6, -30.537],
                    [145.543, -17.594],
                    [145.543, 17.594],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0.333333333333, 0.588235294118, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [-0.015, 659.449], ix: 2 },
              a: { a: 0, k: [-145.678, 30.18], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667, 0.667], y: [1, 1] },
                    o: { x: [0.333, 0.333], y: [0, 0] },
                    t: 92,
                    s: [100, 100],
                  },
                  { t: 97, s: [0, 0] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 7",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 7,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.149, 0],
                    [0, 0],
                    [0, 7.149],
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.148],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.148],
                    [0, 0],
                    [7.149, 0],
                    [0, 0],
                    [0, 7.149],
                  ],
                  v: [
                    [132.659, 30.538],
                    [-132.66, 30.538],
                    [-145.603, 17.593],
                    [-145.603, -17.594],
                    [-132.66, -30.538],
                    [132.659, -30.538],
                    [145.603, -17.594],
                    [145.603, 17.593],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.998915848078, 0.694012989717, 0.016330733954, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [758.797, 740.642], ix: 2 },
              a: { a: 0, k: [145.602, 30.299], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667, 0.667], y: [1, 1] },
                    o: { x: [0.333, 0.333], y: [0, 0] },
                    t: 4,
                    s: [0, 0],
                  },
                  {
                    i: { x: [0.667, 0.667], y: [1, 1] },
                    o: { x: [0.333, 0.333], y: [0, 0] },
                    t: 9,
                    s: [100, 100],
                  },
                  {
                    i: { x: [0.667, 0.667], y: [1, 1] },
                    o: { x: [0.333, 0.333], y: [0, 0] },
                    t: 108,
                    s: [100, 100],
                  },
                  { t: 113, s: [0, 0] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 17",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 8,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.149, 0],
                    [0, 0],
                    [0, 7.149],
                    [0, 0],
                    [-7.149, 0],
                    [0, 0],
                    [0, -7.149],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.149, 0],
                    [0, 0],
                    [0, -7.149],
                    [0, 0],
                    [7.149, 0],
                    [0, 0],
                    [0, 7.149],
                  ],
                  v: [
                    [30.753, 30.537],
                    [-30.753, 30.537],
                    [-43.696, 17.594],
                    [-43.696, -17.594],
                    [-30.753, -30.537],
                    [30.753, -30.537],
                    [43.696, -17.594],
                    [43.696, 17.594],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.998915848078, 0.694012989717, 0.016330733954, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [758.601, 822.165], ix: 2 },
              a: { a: 0, k: [43.499, 30.747], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667, 0.667], y: [1, 1] },
                    o: { x: [0.333, 0.333], y: [0, 0] },
                    t: 19,
                    s: [0, 0],
                  },
                  { t: 24, s: [100, 100] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 18",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 9,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.148, 0],
                    [0, 0],
                    [0, 7.149],
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.149],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.149],
                    [0, 0],
                    [7.148, 0],
                    [0, 0],
                    [0, 7.149],
                  ],
                  v: [
                    [132.6, 53.084],
                    [-132.72, 53.084],
                    [-145.663, 40.141],
                    [-145.663, -40.141],
                    [-132.72, -53.084],
                    [132.6, -53.084],
                    [145.543, -40.141],
                    [145.543, 40.141],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0.333333333333, 0.588235294118, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [-0.424, 948.461], ix: 2 },
              a: { a: 0, k: [-146.087, 53.421], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667, 0.667], y: [1, 1] },
                    o: { x: [0.333, 0.333], y: [0, 0] },
                    t: 34,
                    s: [0, 0],
                  },
                  { t: 39, s: [100, 100] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 16",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 10,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.148, 0],
                    [0, 0],
                    [0, 7.14],
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.148],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.148],
                    [0, 0],
                    [7.148, 0],
                    [0, 0],
                    [0, 7.14],
                  ],
                  v: [
                    [94.974, 30.538],
                    [-95.094, 30.538],
                    [-108.038, 17.597],
                    [-108.038, -17.595],
                    [-95.094, -30.538],
                    [94.974, -30.538],
                    [107.917, -17.595],
                    [107.917, 17.597],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0.333333333333, 0.588235294118, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.132, 1028.93], ix: 2 },
              a: { a: 0, k: [-107.905, 30.268], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667, 0.667], y: [1, 1] },
                    o: { x: [0.333, 0.333], y: [0, 0] },
                    t: 49,
                    s: [0, 0],
                  },
                  { t: 54, s: [100, 100] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 19",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 11,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.149, 0],
                    [0, 0],
                    [0, 7.15],
                    [0, 0],
                    [-7.149, 0],
                    [0, 0],
                    [0, -7.14],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.149, 0],
                    [0, 0],
                    [0, -7.14],
                    [0, 0],
                    [7.149, 0],
                    [0, 0],
                    [0, 7.15],
                  ],
                  v: [
                    [62.307, 30.54],
                    [-62.307, 30.54],
                    [-75.252, 17.59],
                    [-75.252, -17.6],
                    [-62.307, -30.54],
                    [62.307, -30.54],
                    [75.251, -17.6],
                    [75.251, 17.59],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.998915848078, 0.694012989717, 0.016330733954, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [758.695, 1110.135], ix: 2 },
              a: { a: 0, k: [75.149, 30.395], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667, 0.667], y: [1, 1] },
                    o: { x: [0.333, 0.333], y: [0, 0] },
                    t: 64,
                    s: [0, 0],
                  },
                  { t: 69, s: [100, 100] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 20",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 12,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.149, 0],
                    [0, 0],
                    [0, 7.15],
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.15],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.15],
                    [0, 0],
                    [7.149, 0],
                    [0, 0],
                    [0, 7.15],
                  ],
                  v: [
                    [132.659, 63.775],
                    [-132.66, 63.775],
                    [-145.603, 50.825],
                    [-145.603, -50.835],
                    [-132.66, -63.775],
                    [132.659, -63.775],
                    [145.603, -50.835],
                    [145.603, 50.825],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.998915848078, 0.694012989717, 0.016330733954, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [758.766, 1257.929], ix: 2 },
              a: { a: 0, k: [145.571, 63.874], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667, 0.667], y: [1, 1] },
                    o: { x: [0.333, 0.333], y: [0, 0] },
                    t: 79,
                    s: [0, 0],
                  },
                  { t: 84, s: [100, 100] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 15",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 13,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.148, 0],
                    [0, 0],
                    [0, 7.15],
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.15],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.15],
                    [0, 0],
                    [7.148, 0],
                    [0, 0],
                    [0, 7.15],
                  ],
                  v: [
                    [132.6, 30.535],
                    [-132.72, 30.535],
                    [-145.663, 17.595],
                    [-145.663, -17.595],
                    [-132.72, -30.535],
                    [132.6, -30.535],
                    [145.543, -17.595],
                    [145.543, 17.595],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0.333333333333, 0.588235294118, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [0.153, 1338.706], ix: 2 },
              a: { a: 0, k: [-145.51, 30.341], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667, 0.667], y: [1, 1] },
                    o: { x: [0.333, 0.333], y: [0, 0] },
                    t: 95,
                    s: [0, 0],
                  },
                  { t: 100, s: [100, 100] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 21",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 14,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.149, 0],
                    [0, 0],
                    [0, 7.15],
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.15],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.15],
                    [0, 0],
                    [7.149, 0],
                    [0, 0],
                    [0, 7.15],
                  ],
                  v: [
                    [132.659, 30.54],
                    [-132.66, 30.54],
                    [-145.603, 17.59],
                    [-145.603, -17.59],
                    [-132.66, -30.54],
                    [132.659, -30.54],
                    [145.603, -17.59],
                    [145.603, 17.59],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.998915848078, 0.694012989717, 0.016330733954, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [758.637, 1419.908], ix: 2 },
              a: { a: 0, k: [145.442, 30.469], ix: 1 },
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.667, 0.667], y: [1, 1] },
                    o: { x: [0.333, 0.333], y: [0, 0] },
                    t: 110,
                    s: [0, 0],
                  },
                  { t: 115, s: [100, 100] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 10",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 15,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.149, 0],
                    [0, 0],
                    [0, 7.15],
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.14],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.14],
                    [0, 0],
                    [7.149, 0],
                    [0, 0],
                    [0, 7.15],
                  ],
                  v: [
                    [132.659, 63.775],
                    [-132.66, 63.775],
                    [-145.603, 50.835],
                    [-145.603, -50.835],
                    [-132.66, -63.775],
                    [132.659, -63.775],
                    [145.603, -50.835],
                    [145.603, 50.835],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.998915848078, 0.694012989717, 0.016330733954, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [613.195, 1873.145], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 8",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 16,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.148, 0],
                    [0, 0],
                    [0, 7.15],
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.15],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.15],
                    [0, 0],
                    [7.148, 0],
                    [0, 0],
                    [0, 7.15],
                  ],
                  v: [
                    [132.6, 53.085],
                    [-132.72, 53.085],
                    [-145.663, 40.145],
                    [-145.663, -40.135],
                    [-132.72, -53.085],
                    [132.6, -53.085],
                    [145.543, -40.135],
                    [145.543, 40.145],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0.333333333333, 0.588235294118, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [145.663, 1574.135], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 9",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 17,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.149, 0],
                    [0, 0],
                    [0, 7.15],
                    [0, 0],
                    [-7.149, 0],
                    [0, 0],
                    [0, -7.15],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.149, 0],
                    [0, 0],
                    [0, -7.15],
                    [0, 0],
                    [7.149, 0],
                    [0, 0],
                    [0, 7.15],
                  ],
                  v: [
                    [30.753, 30.535],
                    [-30.753, 30.535],
                    [-43.696, 17.595],
                    [-43.696, -17.595],
                    [-30.753, -30.535],
                    [30.753, -30.535],
                    [43.696, -17.595],
                    [43.696, 17.595],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.998915848078, 0.694012989717, 0.016330733954, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [715.102, 1470.515], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 11",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 18,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.148, 0],
                    [0, 0],
                    [0, 7.15],
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.14],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.14],
                    [0, 0],
                    [7.148, 0],
                    [0, 0],
                    [0, 7.15],
                  ],
                  v: [
                    [94.974, 30.54],
                    [-95.094, 30.54],
                    [-108.038, 17.59],
                    [-108.038, -17.6],
                    [-95.094, -30.54],
                    [94.974, -30.54],
                    [107.917, -17.6],
                    [107.917, 17.59],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0.333333333333, 0.588235294118, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [108.038, 1677.76], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 12",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 19,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.149, 0],
                    [0, 0],
                    [0, 7.15],
                    [0, 0],
                    [-7.149, 0],
                    [0, 0],
                    [0, -7.15],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.149, 0],
                    [0, 0],
                    [0, -7.15],
                    [0, 0],
                    [7.149, 0],
                    [0, 0],
                    [0, 7.15],
                  ],
                  v: [
                    [62.307, 30.535],
                    [-62.307, 30.535],
                    [-75.252, 17.595],
                    [-75.252, -17.595],
                    [-62.307, -30.535],
                    [62.307, -30.535],
                    [75.251, -17.595],
                    [75.251, 17.595],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.998915848078, 0.694012989717, 0.016330733954, 1],
                ix: 4,
              },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [683.547, 1758.835], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 13",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 20,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.148, 0],
                    [0, 0],
                    [0, 7.15],
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.15],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-7.148, 0],
                    [0, 0],
                    [0, -7.15],
                    [0, 0],
                    [7.148, 0],
                    [0, 0],
                    [0, 7.15],
                  ],
                  v: [
                    [132.6, 30.54],
                    [-132.72, 30.54],
                    [-145.663, 17.59],
                    [-145.663, -17.59],
                    [-132.72, -30.54],
                    [132.6, -30.54],
                    [145.543, -17.59],
                    [145.543, 17.59],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0.333333333333, 0.588235294118, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [145.663, 1987.46], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 14",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 21,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 106,
      st: -7,
      bm: 0,
    },
  ],
  markers: [],
};
